import { render, staticRenderFns } from "./supply-chain.vue?vue&type=template&id=730295d8&scoped=true"
import script from "./supply-chain.vue?vue&type=script&lang=js"
export * from "./supply-chain.vue?vue&type=script&lang=js"
import style0 from "./supply-chain.vue?vue&type=style&index=0&id=730295d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730295d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('730295d8')) {
      api.createRecord('730295d8', component.options)
    } else {
      api.reload('730295d8', component.options)
    }
    module.hot.accept("./supply-chain.vue?vue&type=template&id=730295d8&scoped=true", function () {
      api.rerender('730295d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/sections/supply-chain.vue"
export default component.exports